<template>
  <div class="parallax-header page-component">
    <div class="parallax-header__rellax-container">
      <img class="parallax-header__rellax-item rellax" src="/images/header/summer/layer-1.png" data-rellax-speed="-8" @load="showLoadingScreen()"/>
      <img class="parallax-header__rellax-item rellax" src="/images/header/summer/layer-2.png" data-rellax-speed="-6" @load="showLoadingScreen()"/>
      <h1 class="parallax-header__title text-center color-white rellax" data-rellax-speed="-6">KRIENS</h1>
      <div class="parallax-header__breaking-news rellax" data-rellax-speed="-6">
        <div class="alert alert--error" v-if="breakingNews.title || breakingNews.content">
          <strong v-if="breakingNews.title">{{ breakingNews.title }}</strong><br v-if="breakingNews.title">
          <prismic-rich-text v-if="breakingNews.content" :field="breakingNews.content" />
        </div>
      </div>
      <img class="parallax-header__rellax-item rellax" src="/images/header/summer/layer-3.png" data-rellax-speed="-4" @load="showLoadingScreen()"/>
      <img class="parallax-header__rellax-item rellax" src="/images/header/summer/layer-4.png" data-rellax-speed="-2" @load="showLoadingScreen()"/>
    </div>
  </div>
</template>

<script>
import Rellax from 'rellax'
import EventBus from '../EventBus'

export default {
  name: 'ParallaxHeader',
  data () {
    return {
      parallaxItemCounter: 0,
      imagesLoadedCounter: 0,
      breakingNews: {
        title: null,
        content: null
      }
    }
  },
  mounted () {
    let rellax = new Rellax('.rellax')
    this.parallaxItemCounter = $('.parallax-header__rellax-item').length

    this.getContent(window.KriensTourismus.language)
    // Listen to Language Change
    EventBus.$on(EventBus.constants.LANGUAGE_CHANGED, (language) => this.getContent(language))
  },
  methods: {
    showLoadingScreen () {
      this.imagesLoadedCounter++
      if (this.imagesLoadedCounter === this.parallaxItemCounter) {
        EventBus.$emit(EventBus.constants.HIDE_LOADING_SCREEN)
      }
    },
    async getContent (language) {
      let document = await this.$prismic.client.getSingle('breakingnews', {lang: language})
      if (document) {
        this.breakingNews.title = document.data.titel
        this.breakingNews.content = document.data.content
      }
    },
  } 
}
</script>